<template>
    <div class="operate-bar-wrap">
        <RoundButton @btnClick="addClick" :text="addGuides" class="add-btn" v-if="!refercence" />
        <LangSelect value="all" class="lang-select" @change="langChange" :requireAll="true"></LangSelect>
        <Select initValue="" :options="usageStatusOptions" @menuClick="usageChange" />
        <Select :initValue="sourceType" :options="sourceOptions" class="source-select" @menuClick="sourceChange" />
        <Select :initValue="sequenceType" :options="sequenceOptions" class="sequence-select" @menuClick="sequenceChange" />
        <Search :placeholder="placeholder" class="strategy-search" @searchChange="searchChange" @inputChange="searchChange"></Search>
        <RoundButton v-show="tagId" @btnClick="showConfigModal" class="classify-config-btn" :text="classifyConfig" />
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import TextGuidesEditModel from "./TextGuidesEditModel";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import LangSelect from "@/components/langSelect";
import ClassifyNameConfig from "@/views/zhiji/components/materialLibrary/ClassifyNameConfig";
import { sourceOptions, sequenceOptions, usageStatusOptions } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import { debounce, strTrim } from "@/views/zhiji/js/common/util.js";

export default {
    name: "GuidesOperate",
    props: ["data", "refercence", "tagId"],
    components: {
        RoundButton,
        Select,
        Search,
        LangSelect
    },
    data() {
        return {
            sourceType: "all",
            sequenceType: "updateTime"
        };
    },
    computed: {
        addGuides() {
            return this.$t("zhiji.materialLibrary.addGuidesBtn");
        },
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        usageStatusOptions() {
            return usageStatusOptions();
        },
        sourceOptions() {
            return sourceOptions();
        },
        sequenceOptions() {
            return sequenceOptions();
        },
        classifyConfig() {
            return this.$t("zhiji.materialLibrary.classifyConfig");
        }
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchStrategy(searchField);
        }, 500);
    },
    methods: {
        addClick() {
            // 新增攻略
            this.$store.dispatch("zhiji/showModal", {
                type: TextGuidesEditModel,
                data: {
                    type: "add",
                    strategyData: {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/queryGuidesList", {});
                    }
                }
            });
        },
        showConfigModal() {
            // 分类名配置弹框
            this.tagId &&
                this.$store.dispatch("zhiji/showModal", {
                    type: ClassifyNameConfig,
                    data: {
                        tagId: this.tagId
                    }
                });
        },
        usageChange(data) {
            this.$store.dispatch("zhiji/queryGuidesList", {
                usageStatus: data.value,
                page: 1,
            });
            this.$emit('switchClick', data);
        },
        sourceChange(data) {
            this.sourceType = data.value;
            this.$store.dispatch("zhiji/queryGuidesList", {
                source: data.value,
                page: 1
            });
            this.$emit("switchClick", data);
        },
        sequenceChange(data) {
            this.sequenceType = data.value;
            this.$store.dispatch("zhiji/queryGuidesList", {
                sequence: data.value,
                page: 1
            });
            this.$emit("switchClick", data);
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchStrategy(data) {
            this.$store.dispatch("zhiji/queryGuidesList", {
                tipName: strTrim(data.value),
                page: 1
            });
            this.$emit("switchClick", data);
        },
        langChange(data) {
            this.$store.dispatch("zhiji/queryGuidesList", {
                lang: data,
                page: 1
            });
            this.$emit("switchClick");
        }
    }
};
</script>

<style scoped lang="less">
.operate-bar-wrap {
    padding: 10px 24px;
    border-bottom: 1px solid #d8e4f0;
    display: flex;
    align-items: center;
    background-color: #fff;
    .add-btn {
        margin-right: 45px;
    }
    .strategy-search {
        width: 318px;
        padding: 0;
        overflow: hidden;
        height: 32px;
    }
    .classify-config-btn {
        border: solid 1px #d8e4f0;
        color: #41475e;
        background: #fff;
        box-shadow: none;
        line-height: 30px;
        border-radius: 4px;
        margin-left: 10px;
        padding: 0 24px;
        &:hover {
            color: #2ec2ff;
        }
    }
    .lang-select {
        width: 120px;
        margin-right: 8px;
    }
}
</style>
